var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        title: _vm.$t("GlobalSetObj.tips"),
        visible: _vm.tipDialog,
        width: "550px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.tipDialog = $event
        },
      },
    },
    [
      Object.keys(_vm.filteredResult).length !== 0
        ? _c("div", [
            _vm._v(
              " " + _vm._s(_vm.$t("receivablePayable.ReasonForFailure")) + " "
            ),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "wrapDialog" },
        [
          _vm._l(_vm.filteredResult, function (value, key) {
            return _c("div", { key: key, staticClass: "order-item" }, [
              _c(
                "span",
                {
                  staticClass: "order-no",
                  staticStyle: { "margin-right": "5px" },
                },
                [_vm._v(_vm._s(key) + ":")]
              ),
              _c("span", { staticClass: "order-msg" }, [
                _vm._v(_vm._s(value.msg)),
              ]),
            ])
          }),
          Object.keys(_vm.filteredResult).length === 0
            ? _c("div", { staticClass: "success-tip" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("receivablePayable.allExecutionSuccess")) +
                    " "
                ),
              ])
            : _vm._e(),
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          staticStyle: { "text-align": "center" },
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: {
                click: function ($event) {
                  _vm.tipDialog = false
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("GlobalSetObj.Close")) + " ")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }